import {NgModule} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {AssignmentRoutingModule} from '../assignment/assignment.routes';
import {BuildingRoutingModule} from '../building/building.routes';
import {CustomerRoutingModule} from '../customer/customer.routes';
import {DashboardRoutingModule} from '../dashboard/dashboard.routes';
import {DeviceRoutingModule} from '../device/device.routes';
import {DrawingRoutingModule} from '../drawing/drawing.routes';
import {FileRoutingModule} from '../file/file.routes';
import {FloorRoutingModule} from '../floor/floor.routes';
import {ManagementRoutingModule} from '../management/management.routes';
import {OwnerRoutingModule} from '../owner/owner.routes';
import {ProductRoutingModule} from '../product/product.routes';
import {ReportRoutingModule} from '../report/report.routes';
import {RoomRoutingModule} from '../room/room.routes';
import {UnauthorizedRoutingModule} from '../unauthorized/unauthorized.routes';
import {UserRoutingModule} from '../user/user.routes';
import {PriceRoutingModule} from '../price/price.routes';
import {ChannelRoutingModule} from '../channel/channel.routes';
import {ThroughputRoutingModule} from '../throughput/throughput.routes';
import {PictureRoutingModule} from '../picture/picture.routes';
import {ArchiveRoutingModule} from '../archive/archive.routes';
import {ProfileRoutingModule} from '../profile/profile.routes';
import {WarrantyRoutingModule} from '../warranty/warranty.routes';
import { CalculationRoutingModule } from '../calculation/calculation.routes';

@NgModule({
  imports: [
    AssignmentRoutingModule,
    BuildingRoutingModule,
    CustomerRoutingModule,
    DashboardRoutingModule,
    DeviceRoutingModule,
    DrawingRoutingModule,
    FloorRoutingModule,
    ManagementRoutingModule,
    OwnerRoutingModule,
    ProductRoutingModule,
    ReportRoutingModule,
    RoomRoutingModule,
    UnauthorizedRoutingModule,
    UserRoutingModule,
    ProfileRoutingModule,
    PriceRoutingModule,
    ChannelRoutingModule,
    PictureRoutingModule,
    ArchiveRoutingModule,
    ThroughputRoutingModule,
    WarrantyRoutingModule,
    FileRoutingModule,
    CalculationRoutingModule,
  ],
  exports: [
    UIRouterModule
  ]
})
export class RoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/routing/routing.module.ts